import { type ReferralsBackofficeState } from "./state";

export const initialState: ReferralsBackofficeState = {
  summary: undefined,
  isSummaryPending: false,
  isSummaryRejected: false,
  weeklySeries: undefined,
  childrenBySupervisor: {},
  pendingChildren: [],
  zones: [],
  referrals: [],
  nextToken: undefined,
  isListPending: false,
  isListRejected: false,
  detail: undefined,
  isDetailPending: false,
  isDetailRejected: false,
  candidates: [],
  isCandidatesPending: false,
  isExporting: false,
  isMutating: false,
  mutationError: undefined,
};
